// Backend fallback icon for subscriptions without a merchant logo — treated
// as "no logo" so callers can render their own placeholder instead.
export const GENERIC_SUBSCRIPTION_ICON_URL = 'https://app.emma-cdn.com/images/icons/subscriptions.png';
const normalize = (url) => url && url !== GENERIC_SUBSCRIPTION_ICON_URL ? url : null;
/**
 * Single source of truth for which logo to show for a transaction,
 * subscription or recurring payment. The user's custom logo (suggestedData)
 * always wins, then the enriched merchant logo, then the subscription
 * merchant info. Placeholder URLs are treated as absent so they never mask
 * a valid lower-priority logo.
 */
const getTransactionLogoUrl = (data) => normalize(data.suggestedData?.iconUrl) ||
    normalize(data.merchant?.iconUrl) ||
    normalize(data.merchantInfo?.iconUrl);
export default getTransactionLogoUrl;
